import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { getClaimsDetails, getClaimsList } from '../services';

import {
  ClaimDeatilsResponseType,
  ClaimSearchInitialState,
  ClaimSearchResponseType,
} from '../utils/Types';

export const ClaimsDataList = createAsyncThunk(
  'claimSearch/getClaimsDataList',
  async (payload: any) => {
    const response = await getClaimsList(payload);
    return response.data;
  }
);

export const fetchClaimDetails = createAsyncThunk(
  'claimSearch/fetchClaimDetails',
  async (params: any) => {
    const res = await getClaimsDetails(params);
    return res.data;
  }
);

export const defaultClaimSearchData: ClaimSearchResponseType = {
  responseInformation: {
    responseCode: '',
    responseMessage: '',
  },
  result: [],
  pagination: {
    currentPage: 0,
    pageSize: 0,
    totalPages: 0,
    totalItems: 0,
    fromItem: 0,
    toItem: 0,
  },
};

export const defaultClaimDeatilsData: ClaimDeatilsResponseType = {
  responseInformation: {
    responseCode: '',
    responseMessage: '',
  },
  result: [],
};

export const initialState: ClaimSearchInitialState = {
  claimsData: defaultClaimSearchData,
  claimDetails: defaultClaimDeatilsData,
};

const claimSearchSlice = createSlice({
  name: 'claims',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        ClaimsDataList.fulfilled,
        (state, action: PayloadAction<ClaimSearchResponseType>) => {
          state.claimsData.pagination = action.payload.pagination;
          state.claimsData.responseInformation =
            action.payload.responseInformation;
          state.claimsData.result = action.payload.result;
        }
      )
      .addCase(fetchClaimDetails.fulfilled, (state, action) => {
        // state.claimDetails.responseInformation =
        //   action.payload.responseInformation;
        state.claimDetails.result = action.payload.result;
      });
  },
});

export const claimSearchSelector = (state: any) => state.claimSearch;

export default claimSearchSlice.reducer;
